import React, { useContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
// react plugin for creating notifications
import NotificationAlert from "react-notification-alert";

// core components
import AdminNavbar from "components/Navbars/AdminNavbar.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import routes from "routes.js";
import { UserContext } from "context/UserContext";

var ps;


class Admin extends React.Component {
  state = {
    sidebarMini: true,
    backgroundColor: "blue",
  };
  notificationAlert = React.createRef();
  mainPanel = React.createRef();
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      document.documentElement.className += " perfect-scrollbar-on";
      document.documentElement.classList.remove("perfect-scrollbar-off");
      ps = new PerfectScrollbar(this.mainPanel.current);
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.documentElement.className += " perfect-scrollbar-off";
      document.documentElement.classList.remove("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.mainPanel.current.scrollTop = 0;
    }
  }
  minimizeSidebar = () => {
    //var message = "Sidebar mini ";
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
      //message += "deactivated...";
    } else {
      this.setState({ sidebarMini: true });
      //message += "activated...";
    }
    document.body.classList.toggle("sidebar-mini");
    /*var options = {};
    options = {
      place: "tr",
      message: message,
      type: "info",
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 7
    };
    this.notificationAlert.current.notificationAlert(options);
    */
  };
  handleColorClick = (color) => {
    this.setState({ backgroundColor: color });
  };
  getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            key={key}
            component={prop.component}
            exact={prop.exact ?? false}
          />
        );
      } else {
        return null;
      }
    });
  };
  getActiveRoute = (routes) => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  getAllowedRoutes = (routes) => {
    const { userHasAnyPermissions } = this.props;
    return routes.filter(
      (r) =>
        !r.requiredPermissions ||
        userHasAnyPermissions([...r.requiredPermissions, "admin"])
    );
  }
  render() {
    const pageName = this.getActiveRoute(routes);
    const allowedRoutes = this.getAllowedRoutes(routes);
    return (
      <div className="wrapper">
        <Helmet titleTemplate="%s | Eletech App" />

        <NotificationAlert ref={this.notificationAlert} />
        <Sidebar
          {...this.props}
          routes={allowedRoutes}
          minimizeSidebar={this.minimizeSidebar}
          backgroundColor={this.state.backgroundColor}
        />
        <div className="main-panel" ref={this.mainPanel}>
          <Helmet>
            <title>{pageName}</title>
          </Helmet>
          <AdminNavbar {...this.props} brandText={pageName} userHasAnyPermissions={this.props.userHasAnyPermissions} />
          <Switch>
            {this.getRoutes(allowedRoutes)}
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <Footer fluid />
        </div>
      </div>
    );
  }
}

const AdminLayoutWrapper = (props) => {
  const { userHasAnyPermissions } = useContext(UserContext)

  return <Admin {...props} userHasAnyPermissions={userHasAnyPermissions} />;
};

export default AdminLayoutWrapper;

